"use client"
import React, { useState, useEffect } from 'react';

const getRollingWeekDays = () => {
  const today = new Date();
  const week = [];
  for (let i = 0; i < 7; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    week.push({
      day: date.toLocaleDateString('en-US', { weekday: 'long' }),
      date: date.getDate(),
      iso: date.toISOString().slice(0, 10),
    });
  }
  return week;
};

interface DaySelectorProps {
  onDateChange: (date: string) => void;
}

const DaySelector = ({ onDateChange }: DaySelectorProps) => {
  const weekDays = getRollingWeekDays();
  const todayIso = new Date().toISOString().slice(0, 10);
  const [selected, setSelected] = useState(todayIso);

  useEffect(() => {
    onDateChange(selected);
  }, [selected, onDateChange]);

  return (
    <div className="bg-gray-100 max-md:bg-white max-md:border-b max-md:border-gray-100 max-md:rounded-none rounded-md p-4 w-full">
      <div className="flex gap-10 text-gray-600 overflow-x-auto scrollbar-hide pb-2">
        {weekDays.map((d) => (
          <button
            key={d.iso}
            onClick={() => setSelected(d.iso)}
            className={`flex flex-col items-center py-2 focus:outline-none whitespace-nowrap flex-shrink-0 ${selected === d.iso ? 'bg-gray-900 text-white rounded px-4 py-2' : ''}`}
          >
            <span>{d.day}</span>
            {/* <span className="text-sm">{d.date}</span> */}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DaySelector; 